var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolveLayout,{tag:"component"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('vue-progress-bar'),_c('notifications',{attrs:{"position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }